<template>
  <div class="relative">
    <!-- IMAGE -->
    <AppImage
      v-if="image"
      :class="{ 'w-1/2': halfWidth }"
      v-bind="$attrs"
      :loading="loading"
      :src="image.permalink"
      :alt="$i18n.locale === 'fr' ? image.alt_fr : image.alt"
    />

    <!-- DOWNLOAD BUTTON -->
    <div
      v-if="downloadable"
      class="group absolute bottom-3 right-3 z-10 flex h-8 w-8 items-center justify-center rounded-sm transition-colors hover:bg-white 2xl:h-10 2xl:w-10"
    >
      <DownloadButton
        class="h-4 w-4 text-white before:absolute before:inset-0 group-hover:text-blue-800 sm:bottom-4 sm:right-4 2xl:h-5 2xl:w-5"
        :aria-label="`${$t('accessibility.download_image')}: ${
          caption || image?.alt
        }`"
        @click="downloadFile(image)"
      />
    </div>

    <!-- GRADIENT BEHIND BUTTON -->
    <div
      v-if="downloadable"
      class="absolute bottom-0 right-0 h-20 w-20 bg-gradient-to-tl from-[#012D43]/30 to-transparent to-50% sm:h-32 sm:w-32"
    />
  </div>
</template>

<script setup>
defineProps({
  image: { type: Object, required: true },
  caption: { type: String, default: '' },
  downloadable: { type: Boolean, default: false },
  loading: { type: String, default: 'lazy' },
  halfWidth: { type: Boolean, default: false },
})

const loading = ref(false)

async function downloadFile(file) {
  // Files won't download directly when they are from another domain (security).
  // This function fetches it first and creates temporary local file which can then be downloaded direct.

  if (!file.is_image && !file.permalink) {
    console.error('File is not an image or has no permalink.')
    return
  }

  loading.value = true

  const response = await fetch(file.permalink)
  // Content to blob address
  const blob = await response.blob()
  // Create hidden downloadable links
  const objectUrl = window.URL.createObjectURL(blob)

  const a = document.createElement('a')
  a.href = objectUrl
  a.download = getTextAfterDoubleColon(file.id) || file.id
  document.body.appendChild(a)

  a.click()

  loading.value = false
  // remove
  setTimeout(() => document.body.removeChild(a), 1000)
}

function getTextAfterDoubleColon(str) {
  const regex = /::(.+)/
  const match = str.match(regex)

  if (match && match.length > 1) {
    return match[1]
  }

  return null
}
</script>
